import {Card, Grid, SectionIntro, Stack} from '@primer/react-brand'
import {BookIcon, PeopleIcon} from '@primer/octicons-react'
import {analyticsEvent} from '../../../../lib/analytics'

export default function ResourcesSection() {
  return (
    <section id="resources" className="lp-Section lp-Section--compact">
      <Grid className="lp-Section-container--centerUntilMedium lp-Grid--noRowGap">
        <Grid.Column span={12}>
          <SectionIntro fullWidth align="center" className="lp-SectionIntro">
            <SectionIntro.Heading size="3" weight="semibold">
              Get the most out of GitHub Copilot
            </SectionIntro.Heading>
          </SectionIntro>

          <Stack
            direction={{narrow: 'vertical', regular: 'horizontal', wide: 'horizontal'}}
            gap="normal"
            padding="none"
          >
            <div className="lp-Resources-card">
              <Card
                ctaText="Explore GitHub Expert Services"
                href="https://github.com/services/"
                {...analyticsEvent({
                  action: 'services',
                  tag: 'link',
                  context: 'consulting_card',
                  location: 'additional_resources',
                })}
              >
                <Card.Icon icon={<PeopleIcon />} color="purple" hasBackground />
                <Card.Heading>Hands-on consulting, guided workshops, and training</Card.Heading>
                <Card.Description>
                  Insights, best practices, and knowledge to help you adopt GitHub quickly and efficiently.
                </Card.Description>
              </Card>
            </div>

            <div className="lp-Resources-card">
              <Card
                ctaText="Read customer stories"
                href="https://github.com/customer-stories"
                {...analyticsEvent({
                  action: 'stories',
                  tag: 'link',
                  context: 'meet_companies_card',
                  location: 'additional_resources',
                })}
              >
                <Card.Icon icon={<BookIcon />} color="purple" hasBackground />
                <Card.Heading>Meet the companies who build with GitHub</Card.Heading>
                <Card.Description>
                  Leading organizations choose GitHub to plan, build, secure and ship software.
                </Card.Description>
              </Card>
            </div>

            <div className="lp-Resources-card">
              <Card
                ctaText="Read blog"
                href="https://github.blog/"
                {...analyticsEvent({
                  action: 'blog',
                  tag: 'link',
                  context: 'latest_trends_card',
                  location: 'additional_resources',
                })}
              >
                <Card.Icon icon={<BookIcon />} color="purple" hasBackground />
                <Card.Heading>Keep up with the latest on GitHub and trends in AI</Card.Heading>
                <Card.Description>
                  Check out the GitHub blog for tips, technical guides, best practices, and more.
                </Card.Description>
              </Card>
            </div>
          </Stack>
        </Grid.Column>
      </Grid>
    </section>
  )
}

try{ ResourcesSection.displayName ||= 'ResourcesSection' } catch {}